<template>
    <v-layout column>
        <v-form ref="form">
            <category-component
                    v-for="category in orderCategories"
                    :selectedInputs="selectedInputs"
                    :categoryData="category"
                    :key="category.id"
                    :slug="slug"
                    @emit-data="handleEmittedData"
            ></category-component>
        </v-form>
        <span v-html="additionalData"></span>
    </v-layout>
</template>

<script>
    import CategoryComponent from '~/components/anfragen/wizards/categories/CategoryComponent'

    export default {
        name: 'step-component',
        components: {
            CategoryComponent
        },
        props: {
            stepData: {
                type: Object,
                required: true,
            },
            additionalData: {
                type: String,
                required: false,
            },
            slug: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                formData: {},
                valid: false,
            }
        },
        methods: {
            validate: function () {
                return !!this.$refs.form.validate();
            },
            reset: function () {
                this.$refs.form.reset();
            },
            showOptions: function (input) {
                return input.options.filter(this.isVisible)
            },
            handleEmittedData: function (data) {
                this.formData = {...this.formData, ...data};
                this.$emit('emit-data', this.formData)
            },
            selectInputs: function (options, targets) {
                if (options.hasOwnProperty('value') &&
                    options.hasOwnProperty('id')) {
                    targets.push(options['id'])
                }
            }
        },
        computed: {
            orderCategories: function () {
                if ('categories' in this.stepData)
                    this.stepData.categories.sort((x, y) => {
                        return x.order_index - y.order_index
                    });
                return this.stepData.categories;
            },
            selectedInputs: function () {
                let selectedInputs = [];
                for (const option in this.formData) {
                    if (this.formData.hasOwnProperty(option)) {
                        if (Array.isArray(this.formData[option])) {
                            this.formData[option].forEach(item => {
                                this.selectInputs(item, selectedInputs)
                            });
                        } else {
                            this.selectInputs(this.formData[option], selectedInputs)
                        }
                    }
                }
                return selectedInputs;
            }
        }
    }
</script>
